export const getEquityCreditRows = state => (
    state.staticDataMappings.equityCreditRows
);

export const getIsdaRows = state => (
    state.staticDataMappings.isdaRows
);

export const getCommodityRows = state => (
    state.staticDataMappings.commodityRows
);

export const getEquityMappingRows = state => (
    state.staticDataMappings.equityMappingRows
);

export const getCurrencyMappingRows = state => (
    state.staticDataMappings.currencyMappingRows
);

export const getCommodityLoading = state => (
    state.staticDataMappings.commodityLoading
);

export const getEquityCreditLoading = state => (
    state.staticDataMappings.equityCreditLoading
);

export const getEquityMappingLoading = state => (
    state.staticDataMappings.equityMappingLoading
);

export const getIsdaLoading = state => (
    state.staticDataMappings.isdaLoading
);

export const getCurrencyMappingLoading = state => (
    state.staticDataMappings.currencyMappingLoading
);

export const getCurrencyDropdownOptions = state => (
    state.staticDataMappings.currencyMappingDropdown
);

export const getIsdaMappingDropdownOptions = state => (
    state.staticDataMappings.isdaMappingDropdownOptions
);

export const getCommodityMappingDropdownOptions = state => (
    state.staticDataMappings.commodityMappingDropdownOptions
);

export const getFetchedIsdaMappingOptions = state => (
    state.staticDataMappings.fetchedIsdaMappingOptions
);

export const getFetchedCommodityMappingOptions = state => (
    state.staticDataMappings.fetchedCommodityMappingOptions
);

export const getFetchedProductClassOptions = state => (
    state.staticDataMappings.fetchedProductClassOptions
);

export const getFetchedCurrencyOptions = state => (
    state.staticDataMappings.fetchedCurrencyOptions
);

export const getDefaultSort = state => (
    state.staticDataMappings.gridSorting
);

export const getStandardProductClassRows = state => (
    state.staticDataMappings.standardProductClassRows
);

export const getStandardProductClassDropdown = state => (
    state.staticDataMappings.standardProductClassDropdown
);

export const getStandardProductClassLoading = state => (
    state.staticDataMappings.standardProductClassLoading
);
